'use strict';

let theme = {

    init: function () {
        this.mobileOffcanvas();
        this.scrollCue();
        this.swiperSlider();
        this.smoothScrollToTop();
    },

    /**
     * Mobile Offcanvas Navigation
     * Handles dual offcanvas navigation for mobile with submenu support
     */
    mobileOffcanvas: () => {
        // Get references to both offcanvas instances
        const mainOffcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasNavbar'));
        const submenuOffcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasSubmenu'));

        // Get the navbar toggler button
        const navbarToggler = document.querySelector('.navbar-toggler');

        // Flag to track transitions between offcanvas panels
        let isTransitioning = false;

        // Intercept the toggle button click
        navbarToggler.addEventListener('click', function (e) {
            // If submenu is open, prevent default and close everything
            if (document.getElementById('offcanvasSubmenu').classList.contains('show')) {
                e.preventDefault();
                e.stopPropagation();

                // Hide both offcanvas panels
                submenuOffcanvas.hide();
                mainOffcanvas.hide();

                // Reset toggler state
                setTimeout(() => {
                    navbarToggler.setAttribute('aria-expanded', 'false');
                    isTransitioning = false;
                }, 300);

                return false;
            }
        });

        // Listen for offcanvas show/hide events to sync the hamburger icon state
        document.getElementById('offcanvasNavbar').addEventListener('hidden.bs.offcanvas', function () {
            // Only set to false if submenu is also closed AND we're not transitioning
            if (!document.getElementById('offcanvasSubmenu').classList.contains('show') && !isTransitioning) {
                navbarToggler.setAttribute('aria-expanded', 'false');
            }
        });

        document.getElementById('offcanvasNavbar').addEventListener('shown.bs.offcanvas', function () {
            navbarToggler.setAttribute('aria-expanded', 'true');
            isTransitioning = false;
        });

        // Add events for submenu offcanvas
        document.getElementById('offcanvasSubmenu').addEventListener('shown.bs.offcanvas', function () {
            navbarToggler.setAttribute('aria-expanded', 'true');
            isTransitioning = false;
        });

        document.getElementById('offcanvasSubmenu').addEventListener('hidden.bs.offcanvas', function () {
            // Only set to false if main nav is also closed AND we're not transitioning
            if (!document.getElementById('offcanvasNavbar').classList.contains('show') && !isTransitioning) {
                navbarToggler.setAttribute('aria-expanded', 'false');
            }
        });

        // Handle parent menu items with dropdown class
        const parentItems = document.querySelectorAll('#offcanvasNavbar .dropdown > a');

        parentItems.forEach(item => {
            item.addEventListener('click', function (e) {
                // Only handle for mobile view
                if (window.innerWidth < 992) {
                    e.preventDefault();

                    // Get the submenu
                    const submenu = this.nextElementSibling;
                    // Update the submenu title
                    document.getElementById('offcanvasSubmenuLabel').textContent = this.textContent.trim();

                    // Clone the submenu items to the secondary offcanvas
                    const submenuContainer = document.getElementById('submenuContainer');
                    submenuContainer.innerHTML = '';
                    submenuContainer.appendChild(submenu.cloneNode(true));

                    // Set transitioning flag to prevent icon state change
                    isTransitioning = true;

                    // Hide main offcanvas and show submenu offcanvas
                    mainOffcanvas.hide();

                    setTimeout(() => {
                        submenuOffcanvas.show();
                    }, 400);
                }
            });
        });

        // Back button functionality
        document.querySelector('.back-to-main').addEventListener('click', function () {
            // Set transitioning flag to prevent icon state change
            isTransitioning = true;

            submenuOffcanvas.hide();
            setTimeout(() => {
                mainOffcanvas.show();
            }, 300);
        });
    },

    /**
     * Sub Menus
     * Enables multilevel dropdown
     */
    subMenu: () => {
        (function ($bs) {
            const CLASS_NAME = 'has-child-dropdown-show';
            $bs.Dropdown.prototype.toggle = function (_original) {
                return function () {
                    document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
                        e.classList.remove(CLASS_NAME);
                    });
                    let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
                    for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
                        dd.classList.add(CLASS_NAME);
                    }
                    return _original.call(this);
                }
            }($bs.Dropdown.prototype.toggle);
            document.querySelectorAll('.dropdown').forEach(function (dd) {
                dd.addEventListener('hide.bs.dropdown', function (e) {
                    if (this.classList.contains(CLASS_NAME)) {
                        this.classList.remove(CLASS_NAME);
                        e.preventDefault();
                    }
                    e.stopPropagation();
                });
            });
        })(bootstrap);
    },

    scrollCue: () => {
        scrollCue.init({
            interval: -400,
            duration: 700,
            percentage: 0.8
        });
        scrollCue.update();
    },
    /**
     * Swiper Slider
     * Enables carousels and sliders
     * Requires assets/js/vendor/swiper-bundle.min.js
     */
    swiperSlider: function () {

        const partnersClients = document.querySelector('.swiper-partners-clients');

        if (partnersClients && typeof Swiper !== 'undefined') {
            try {
                const swiper = new Swiper(".swiper-partners-clients", {
                    slidesPerView: 3,
                    spaceBetween: 60,
                    loop: true,
                    centeredSlides: false,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                        reverseDirection: false
                    },
                    speed: 5000,
                    freeMode: {
                        enabled: true,
                        momentum: false,
                    },
                    allowTouchMove: false,
                    grabCursor: false,
                    breakpoints: {
                        480: {
                            slidesPerView: 6,
                            spaceBetween: 50,
                        },
                        768: {
                            slidesPerView: 7
                        },
                        1200: {
                            slidesPerView: 8
                        },
                        1920: {
                            slidesPerView: 12
                        }
                    },
                });
            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }


        // Initialize news swiper
        const swiperNewsElement = document.querySelector('.swiper-news');

        if (swiperNewsElement && typeof Swiper !== 'undefined') {
            try {
                const swiperNews = new Swiper('.swiper-news', {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    }
                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }


        // Initialize training overview Swiper
        const trainingOverviewElement = document.querySelector('.training-overview.swiper-container');

        if (trainingOverviewElement && typeof Swiper !== 'undefined') {
            try {
                const trainingSwiper = new Swiper('.training-overview.swiper-container', {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                    },
                });
            } catch (error) {
                console.error('Error initializing Training Overview Swiper:', error);
            }
        }


        // Initialize LinkedIn Swiper
        const swiperLinkedInFeed = document.querySelector('.swiper-linkedin-feed');

        if (swiperLinkedInFeed && typeof Swiper !== 'undefined') {
            try {
                const swiperLinkedInFeed = new Swiper('.swiper-linkedin-feed', {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    }
                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }

    },


    smoothScrollToTop: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const scrollToTopButton = document.getElementById('scrollToTop');

            if (!scrollToTopButton) return;

            scrollToTopButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

            window.addEventListener('scroll', () => {
                if (window.scrollY > 300) {
                    scrollToTopButton.classList.add('visible');
                } else {
                    scrollToTopButton.classList.remove('visible');
                }
            });
        });
    },

    /**
     * GLightbox
     * Enables lightbox functionality
     * Requires assets/js/vendor/glightbox.js
     */

    lightbox: () => {
        const lightbox = GLightbox({
            selector: '*[data-glightbox]',
            touchNavigation: true,
            loop: false,
            zoomable: false,
            autoplayVideos: true,
            moreLength: 0,
            slideExtraAttributes: {
                poster: ''
            },
            plyr: {
                css: '',
                js: '',
                config: {
                    ratio: '',
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            },
        });
    },

}
theme.init();
